"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountService = void 0;
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
class AccountService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        this.RESOURCE = 'profile';
        //Invalid object name 'PersonInterests' No esta la tabla
        this.getProfile = async (email) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/${this.RESOURCE}`;
            const response = await axios_1.default.post(URL, JSON.stringify({ email: email }), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        //Invalid object name 'PersonInterests' No esta la tabla
        this.getProfileData = async (id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/${this.RESOURCE}/${id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        //No se usa en POINT no encuentro un lugar donde lo usen en red dragon
        this.getStudentInfo = async (ou, id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/student/${ou}/${id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.searchStudent = async (ou, criteria, includePersons) => {
            /*  const abortController = new AbortController();
              if (abortController) {
                  abortController.abort();
              }*/
            let URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/student/${ou}/search/${criteria.replace(/\s/g, '+')}`;
            if (includePersons) {
                URL = `${URL}?includePersons=true`;
            }
            const response = await axios_1.default.get(URL, { /*signal: abortController.signal,*/ headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCatalogInterestArea = async () => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/catalogs/catalog/courses.CourseSkillCat?skill_type_id=1`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getSubInterestAreas = async (person_id, academies_ids) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/profile/${person_id}/interests`;
            const response = await axios_1.default.post(URL, JSON.stringify({ "academies_ids": academies_ids }), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        //Este servicio no esta implementado en POINT no se que lleva body ni que responde
        this.updateProfile = async (id, body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/${this.RESOURCE}/${id}`;
            const response = await axios_1.default.put(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.updateProfileData = async (id, body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/${this.RESOURCE}/${id}`;
            const response = await axios_1.default.put(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        //No se cacha la respuesta del servicio y si lo consumo me marca error de tipo de datos 
        this.createStudentQR = async (user) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/student/${user.ou}/${user.person_id}/qr-code`;
            const response = await axios_1.default.post(URL, JSON.stringify({ "idUnidadOperativa": user.student_id || user.person_id }), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        //No se usa actualmente en POINT este servicio
        this.getPreferences = async (personId) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/${this.RESOURCE}/${personId}/preferences`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        //No se usa actualmente en POINT este servicio
        this.updatePreferences = async (personId, preferences) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/${this.RESOURCE}/${personId}/preferences`;
            const response = await axios_1.default.put(URL, JSON.stringify({ "preferences": preferences }), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        //No responde nada no se guarda una respuesta del consumo del servicio
        this.updateProfilePicture = async (personId, imgUrl) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/${this.RESOURCE}/picture`;
            const payload = {
                'person_id': personId,
                'img_url': imgUrl
            };
            const response = await axios_1.default.post(URL, JSON.stringify(payload), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.deleteProfileData = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/${this.RESOURCE}/${body.person_id}?dataset=${body.dataSet}&row_id=${body.row_id}`;
            const response = await axios_1.default.delete(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.requestDeleteaccount = async (user) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/delete-account`;
            const payload = {
                'user': user,
            };
            const response = await axios_1.default.post(URL, JSON.stringify(payload), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getStudentScheduleCalifications = async (ou, user_id, type) => {
            if (ou && ou.toLowerCase() == 'talisis')
                return Promise.resolve({ data: { persona: null } });
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/student/${ou}/${user_id}/academic?type=${type}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getDashboard = async (person_id, ou) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/profile/${person_id}/dashboard/${ou}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getProfilePercentage = async (profileData) => {
            const percentageProfileData = JSON.stringify(profileData);
            const completedJsonData = JSON.parse(percentageProfileData);
            const completedData = deleteKeys(completedJsonData);
            const totalFields = Object.keys(completedData).length;
            let emptyFields = Object.keys(completedData).filter(x => completedData[x] === null ||
                completedData[x].length === 0 ||
                completedData[x] === 'null' ||
                completedData[x] === 'undefined').length;
            if ('personal_web' in completedData)
                emptyFields--;
            if (Object.keys(completedData.address).length === 0)
                emptyFields++;
            const getGrandTotal = totalFields - emptyFields;
            return Math.round(getGrandTotal / totalFields * 100);
        };
        this.getProfilePercentageV2 = async (profileData, hasPhoto) => {
            const percentageProfileData = JSON.stringify(profileData);
            const completedJsonData = JSON.parse(percentageProfileData);
            // +1 profile picture
            const totalFields = valueToValidateProfile.length + 1;
            let emptyFields = valueToValidateProfile.filter(value => completedJsonData[value] === undefined ||
                completedJsonData[value] === null ||
                completedJsonData[value].length === 0 ||
                (typeof completedJsonData[value] === 'object' && Object.keys(completedJsonData[value]).length === 0) ||
                completedJsonData[value] === 'null' ||
                completedJsonData[value] === 'undefined').length;
            if (!hasPhoto)
                emptyFields++;
            return Math.round((totalFields - emptyFields) / totalFields * 100);
        };
        this.getSkillsNames = async (skills) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/profile/skills-by-id`;
            const response = await axios_1.default.post(URL, JSON.stringify(skills), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.sendVerificationCode = async (usrData) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/profile/verification-code`;
            const response = await axios_1.default.post(URL, JSON.stringify(usrData), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.updatePassword = async (usrData) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/profile/update-password`;
            const response = await axios_1.default.put(URL, JSON.stringify(usrData), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.ENV = ENV;
        this.KEY = key;
    }
}
exports.AccountService = AccountService;
const deleteKeys = (dataObj) => {
    delete dataObj.bill_to;
    delete dataObj.central_test_assessment_id;
    delete dataObj.central_test_candidate_id;
    delete dataObj.external_id;
    delete dataObj.has_evaluations;
    delete dataObj.is_active;
    delete dataObj.is_admin;
    delete dataObj.nationality_code;
    delete dataObj.password;
    delete dataObj.password_token;
    delete dataObj.referred_by;
    delete dataObj.role_id;
    delete dataObj.user_id;
    delete dataObj.personal_web;
    delete dataObj.profile_picture_url;
    return dataObj;
};
const valueToValidateProfile = [
    "first_name",
    "last_name",
    "interestArea",
    "email",
    "about_me",
    "gender",
    "phone_number",
    "birth_date",
    "address",
    "linkedin_profile_url",
    "facebook_profile_url",
    "instagram_profile_url",
    "twitter_profile_url",
    "career",
    "jobHistory",
    "education"
];
